import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../../shared/button.component';
import { ReduxAlert } from '../../shared/alert.component';

import {
  uploadedBatchAdjustmentsSelector,
  importingBatchAdjustmentsSelector,
  uploadingBatchAdjustmentsSelector,
} from './store/selectors';
import { uploadBatchAdjustments, resetUploadedBatchAdjustments, importBatchAdjustments } from './store/actions';
import { BatchAdjustmentPropType } from './propTypes';
import HamburgerDropdown from './hamburgerDropdown.component';
import BatchAdjustmentsGrid from './batchAdjustmentsGrid.component';
import SecondaryMenu from '../../menu/secondaryMenu.component';

import {
  currentPeriodSelector,
  environmentSuffixSelector,
} from '../../shared/store/selectors';
import { ClientIsLockedOverlay } from '../../shared/clientLocked/ClientLockedOverlay';
import { clientLockedMessages } from '../../shared/clientLocked/messages';

class BatchTaxEntriesPage extends PureComponent {
  static propTypes = {
    currentPeriod: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    uploadedBatchAdjustments: PropTypes.arrayOf(BatchAdjustmentPropType),
    importingBatchAdjustments: PropTypes.bool.isRequired,
    uploadingBatchAdjustments: PropTypes.bool.isRequired,
    uploadBatchAdjustments: PropTypes.func.isRequired,
    resetUploadedBatchAdjustments: PropTypes.func.isRequired,
    importBatchAdjustments: PropTypes.func.isRequired,
    environmentSuffix: PropTypes.string.isRequired,
  };

  componentWillUnmount() {
    this.props.resetUploadedBatchAdjustments();
  }

  fileToImportChange = event => {
    const { uploadBatchAdjustments, currentPeriod } = this.props;
    const fileToImport = event.target.files[0];
    uploadBatchAdjustments(fileToImport, currentPeriod.name);
  };

  importBatchAdjustments = () => {
    const { importBatchAdjustments, uploadedBatchAdjustments, currentPeriod } = this.props;
    importBatchAdjustments(uploadedBatchAdjustments, currentPeriod.name);
  };

  getImportErrorsNum = batchAdjustments => batchAdjustments.reduce((errors, batchAdjustment) =>
    batchAdjustment.validationData ? errors + 1 : errors
  , 0);

  generateTemplateFileName = () => `TLS_Adjustments_${this.props.currentPeriod.name}${this.props.environmentSuffix}.xlsx`;

  render() {
    const {
      currentPeriod,
      uploadedBatchAdjustments,
      importingBatchAdjustments,
      uploadingBatchAdjustments,
    } = this.props;

    const importErrors = this.getImportErrorsNum(uploadedBatchAdjustments);

    return (
      <ClientIsLockedOverlay message={clientLockedMessages.BATCH_ADJUSTMENTS_PAGE}>
        <div className="batch-adjustments-page">
          <SecondaryMenu>
            <div className="current-period">{currentPeriod.name}</div>
            <div className="hamburger-dropdown ml-auto text-right">
              <HamburgerDropdown
                period={currentPeriod}
                fileToImportChange={this.fileToImportChange}
                templateFileName={this.generateTemplateFileName()}
              />
            </div>
          </SecondaryMenu>
          <div className="page">
            <div className="container-fluid">
              <ReduxAlert/>
              <div className="row no-gutters page-content-container">
                <div className="col-xs-12 col-md-4">
                  <h5>Batch Adjustments</h5>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <BatchAdjustmentsGrid
                    importErrors={importErrors}
                    batchAdjustments={uploadedBatchAdjustments}
                    isLoading={importingBatchAdjustments || uploadingBatchAdjustments}
                  />
                </div>
              </div>
              <div className="d-flex flex-row align-items-end page-content-container">
                <Button
                  type="button"
                  kind="primary"
                  disabled={importErrors > 0 || uploadedBatchAdjustments.length === 0}
                  className="ml-auto"
                  onClick={this.importBatchAdjustments}
                >
                  Submit Adjustments
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ClientIsLockedOverlay>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentPeriod: currentPeriodSelector(state),
    uploadedBatchAdjustments: uploadedBatchAdjustmentsSelector(state),
    importingBatchAdjustments: importingBatchAdjustmentsSelector(state),
    uploadingBatchAdjustments: uploadingBatchAdjustmentsSelector(state),
    environmentSuffix: environmentSuffixSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    uploadBatchAdjustments,
    importBatchAdjustments,
    resetUploadedBatchAdjustments,
  }
)(BatchTaxEntriesPage);
